import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

import * as CryptoJS from 'crypto-js';

declare var $: any;
declare var nativeToast: any;

export const enum UserTypes {
  Visitor = 0, Builder = 1, Agent = 2, Admin = 3, Provider = 4
}

export const enum RequestType {
  Buy = 1, Rent = 2, Sale = 3
}

export const enum PropertyType {
  Residential = 1, Commercial = 2, Land = 3
}

export const enum RequestForTypes {
  Self = "Self", Others = "Others"
}

export const PropertyMeasurement: any[] = [
  { Id: 1, Name: "Sq. ft" },
  { Id: 2, Name: "Sq. yd" },
  { Id: 3, Name: "Sq. mts" },
  { Id: 4, Name: "BHK" },
  { Id: 5, Name: "Acre" }
]

export interface SMSEntity {
  Text: string;
  Number: string;
  SenderId?: string;
  DRNotifyUrl?: string;
  DRNotifyHttpMethod?: string;
  Tool?: string;
}


export interface SMSRequest {
  Text: string;
  Number: string;
  Otp?: string;          // ✅ optional — server stores it when present
  ShareToken?: string;   // ✅ optional — from /share/{token}
}

export interface VentureResources {
  ContentType: string;
  FileName: string;
  FileType: string;
  Label: string;
  isVideo: boolean;
  isImage: boolean;
  isDocument: boolean;
  isResources: boolean;
}


@Injectable({
  providedIn: 'root'
})

export class CommonService {

  private encryptSecretKey: string = '';

  constructor(private _http: HttpClient) { }

  encryptData(data: any) {
    try {
      return CryptoJS.AES.encrypt(JSON.stringify(data), this.encryptSecretKey).toString();
    } catch (e) {
      //console.log(e);
    }
  }

  decryptData(data: any) {
    try {
      const bytes = CryptoJS.AES.decrypt(data, this.encryptSecretKey);
      if (bytes.toString()) {
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      }
      return data;
    } catch (e) {
      //console.log(e);
    }
  }

  encryptPostData(data: any) {
    try {
      const key = CryptoJS.enc.Utf8.parse('55JvBD&5IJeynGNd');
      const iv = CryptoJS.enc.Utf8.parse('3MpKHVjAe!7Ymd!l');
      var result = CryptoJS.AES.encrypt(data, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }).toString();
      return result.replace(/\+/g, "");
    } catch (e) {
      //console.log(e);
    }
  }

  decryptPostData(data: any) {
    try {
      const key = CryptoJS.enc.Utf8.parse('55JvBD&5IJeynGNd');
      const iv = CryptoJS.enc.Utf8.parse('3MpKHVjAe!7Ymd!l');
      var decrypted = CryptoJS.AES.decrypt(data, key,
        {
          keySize: 128 / 8,
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        });
      return decrypted.toString(CryptoJS.enc.Utf8);

    } catch (e) {
      //console.log(e);
    }
  }

  CallToster(type: string, message: string): void {
    nativeToast({
      message: message,
      type: type == 'E'
        ? 'error'
        : type == 'S'
          ? 'success'
          : type == 'W'
            ? 'warning'
            : 'info',
      position: 'center',
      timeout: 5000
    });
  }

  DismissModel() {
    setTimeout(() => {
      $('.modal').modal('hide');
      $('.modal-backdrop').modal('hide');
      $(".modal-backdrop").css("display", "none");
    }, 500);
  }

  LoadDataTable(strID: string) {
    $(document).ready(function () {
      setTimeout(() => {
        $('#' + strID + '').DataTable({
          retrieve: true,
          paging: true,
          ordering: false,
          info: true
        });
      }, 100);
    });
  }

  DestroyDatatable() {
    if ($.fn.DataTable.isDataTable('.dt-cap-data-table')) {
      $('.dt-cap-data-table').dataTable().fnClearTable();
      $('.dt-cap-data-table').dataTable().fnDestroy();
    }
  }


  SendSMS(
    smsText: string,
    smsNumber: string,
    otp?: string,
    shareToken?: string
  ): Observable<any> {

    const jsonPayload: SMSRequest = {
      Text: smsText,
      Number: smsNumber
    };

    if (otp) jsonPayload.Otp = otp;         // ✅ store on server
    if (shareToken) jsonPayload.ShareToken = shareToken;  // ✅ optional audit

    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(
      environment.apiUrl + "api/communication/sendsms",
      jsonPayload,
      httpOptions
    );
  }


  postMsgWithUrlToWhatsapp(ToNum: string, Msg: string): Observable<any> {
    let jsonPayload = {
      "number": "91" + ToNum,
      "type": "media",
      "message": Msg,
      "media_url": environment.appLogoURL
    };

    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };
    return this._http.post(environment.apiUrl + "api/communication/whatsappnotificationwithmedia/", jsonPayload, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
    );
  }

  SaveReferralInfo(mobile: string, refCode: string): Observable<any> {
    let jsonPayload = {
      "ReferralCode": refCode,
      "MobileNumber": mobile
    };

    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(
      environment.apiUrl + "api/user/joinReferral",
      jsonPayload,
      httpOptions
    );
  }


  sendAdminNotification(actionType: string, userName: string, mobile: string, propertyType?: string): Observable<any> {
    let jsonPayload = {
      ActionType: actionType,
      UserName: userName,
      Mobile: mobile,
      PropertyType: propertyType || ""
    };

    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(
      environment.apiUrl + "api/communication/sendadminnotification/",
      jsonPayload,
      httpOptions
    );
  }



}
